import { IconX } from '@tabler/icons-react'
import { Flex } from 'antd/es'
import React, { useCallback } from 'react'

import MediaView from '@/components/shared/media-view'
import { Media } from '@/model/media'
import { updateMessageDraft } from '@/redux/message-draft'
import { useAppDispatch } from '@/redux/utils'

import s from './post-video-preview.module.css'

export interface PostVideoPreviewProps {
  creatorId: number
  fanUserId: number
  media: Media
}

export default function PostVideoPreview({
  creatorId,
  fanUserId,
  media,
}: PostVideoPreviewProps) {
  const dispatch = useAppDispatch()

  const removeMedia = useCallback(() => {
    void dispatch(
      updateMessageDraft({ creatorId, fanUserId, changes: { medias: [] } }),
    )
  }, [creatorId, dispatch, fanUserId])

  return (
    <Flex align="flex-start" gap={8}>
      <MediaView className={s.VideoPreview} media={media} />
      <IconX className="icon-button" size={14} onClick={removeMedia} />
    </Flex>
  )
}
